import { styled } from '@mui/material';
import { DatagridConfigurable } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils/getColumnStyle';

export const DatagridConfigurableStyled = styled(DatagridConfigurable)({
  '& .state': {
    width: '249px',
    minWidth: '249px',
    maxWidth: 'none',
    whiteSpace: 'nowrap',
  },
  '& .column-commission.task': { ...getColumnStyle(241) },
  '& .column-commission.period': { ...getColumnStyle(241) },
  '& .column-commission.provider': { ...getColumnStyle(107) },
  '& .column-commission.merchant': { ...getColumnStyle(179) },
  '& .column-commission.currency': { ...getColumnStyle(195) },
  '& .column-commission.transactionTypes': { ...getColumnStyle(168) },
  '& .column-recalculate': { ...getColumnStyle(215) },
  '& .column-startedAt': { ...getColumnStyle(122) },
  '& .column-completedAt': { ...getColumnStyle(118) },
});
